var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-tooltip',{attrs:{"bottom":_vm.bottom,"top":!_vm.bottom},scopedSlots:_vm._u([{key:"activator",fn:function({ on, attrs }){return [_c('v-chip',_vm._g(_vm._b({staticClass:"px-1",attrs:{"label":"","outlined":_vm.outlined,"color":_vm.color}},'v-chip',attrs,false),on),[_vm._t("default")],2)]}}],null,true)},[_vm._v(" "+_vm._s(_vm.tooltip)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }